import React from "react";
import styles from "./HeaderLogo.module.css";
import {Link} from "react-router-dom";
import useResponsive from "../../../../common/useResponsive";
import {css} from "@emotion/css";
// import logo from "../logo-symbol.png";
// import TimeSnapLogo from "../../../../assets/image/timeSnapLogo.svg";
import iconXenera from "./assets/logo.png";
export function HeaderLogo() {
    const {isMobile} = useResponsive();
    return (
        <Link to="/" className={styles.logo}>
            {process.env.REACT_APP_CUSTOMER === "MHPS" ? (
                <HeaderLogoMHPS/>
            ) : (
                <div
                    style={{
                        marginTop: isMobile ? "0" : "12px"
                    }}
                >
                    <img alt={"xenera"} height={isMobile ? "20px" : "40px"} src={iconXenera}/>
                    <h1 className={css`
                      color: #00538a;
                      margin: 0;
                      font-weight: bold;
                      font-size: ${isMobile ? 10 : 18}px;
                    `}
                    >EduSphere - みんなの学習室</h1>
                </div>
            )}
        </Link>
    );
}

function HeaderLogoMHPS() {
    return (
        <>
            {/* <img
                src={logo}
                alt=""
                height={40}
            /> */}

            <span className={styles.label}>MHPS Video Knowledge Base</span>
        </>
    );
}
